import { useMemo } from 'react';
import { Viewport } from '@react-three/fiber';
import { VIEWPORT } from '../../constants/config';
import { projects } from '../../data/projects';

export function useResponsiveValues(viewport: Viewport) {
  return useMemo(() => {
    // Utiliser directement window.innerWidth pour la détection des breakpoints
    const screenWidth = window.innerWidth;

    // Calculer la base de l'échelle en fonction de la plus petite dimension
    const minDimension = Math.min(viewport.width, viewport.height);
    let scale: number;
    let spiralRadius: number;

    if (screenWidth < VIEWPORT.BREAKPOINTS.MOBILE) {
      scale = VIEWPORT.IMAGE_SCALE.MOBILE;
      spiralRadius = 4;
    } else if (screenWidth < VIEWPORT.BREAKPOINTS.TABLET) {
      scale = VIEWPORT.IMAGE_SCALE.TABLET;
      spiralRadius = 5;
    } else {
      scale = VIEWPORT.IMAGE_SCALE.DESKTOP;
      spiralRadius = 9;
    }

    // Ajuster la taille de base en fonction de la dimension minimale
    const baseHeight = minDimension * scale;

    return {
      radius: spiralRadius,
      imageScale: [baseHeight, baseHeight] as [number, number],
      heightLoop: 35,
      baseScale: 1.5,
      projectsPerLoop: projects.length,
      startOffset: Math.PI / projects.length,
    } as const;
  }, [viewport.width, viewport.height, projects.length]);
}
